import { request } from "./base";

export const adminAuthApi = {
	async getUserSessions(userId: string) {
		return request<
			{
				id: string;
				token: string;
				userId: string;
				expiresAt: string;
				createdAt: string;
				updatedAt: string;
				ipAddress: string | null;
				userAgent: string | null;
			}[]
		>(`/api/admin/users/${userId}/sessions`);
	},

	async revokeSession(userId: string, sessionId: string) {
		return request(`/api/admin/users/${userId}/sessions/${sessionId}`, {
			method: "DELETE",
		});
	},

	async revokeAllSessions(userId: string) {
		return request(`/api/admin/users/${userId}/sessions`, {
			method: "DELETE",
		});
	},

	async getUserAccounts(userId: string) {
		return request<
			{
				id: string;
				providerId: string;
				accountId: string;
				createdAt: string;
			}[]
		>(`/api/admin/users/${userId}/accounts`);
	},

	async unlinkAccount(userId: string, accountId: string) {
		return request(`/api/admin/users/${userId}/accounts/${accountId}`, {
			method: "DELETE",
		});
	},
};
